import { DineroObject } from 'dinero.js';

export type Amount = Pick<DineroObject, 'amount' | 'currency'>;

export const isAmountObject = (value: unknown): value is Amount => {
  return value && typeof value['amount'] === 'number' && typeof value['currency'] === 'string';
};
